<div style="display: flex">
    <p-dialog header="Are you sure?" [maximizable]="false" [visible]="this.IsDialogVisible" [closable]="false"
        [closeOnEscape]="false">
        <div>
            <p>
                You have unsaved changes. <br />
                Do you want to apply or discard your changes?
            </p>
        </div>

        <ng-template #footer >
            <button type="button" pButton icon="pi pi-check" (click)="onDialogButtonClicked('apply')"
                class="p-button-secondary" label="Apply"></button>
            <button type="button" pButton icon="pi pi-check" (click)="onDialogButtonClicked('discard')"
                class="p-button-secondary" label="Discard"></button>
        </ng-template>
    </p-dialog>
</div>

<!-- <h4 style="justify-self: center">
    <p id="description">
        Period Reprocessing (Step 2 and Step 3) recalculates costs and generates
        invoices. This is the recommended approach when changes have been made
        in eFAACT with no QuickBooks changes for the selected period. Step 1 is
        required to process a period for the first time or import direct charge
        changes made in QuickBooks.
    </p>
</h4> -->






<!-- <p-accordion [multiple]="true">
    <div class="shadow-box">
        <p-accordionTab header="Calculate or Commit" [selected]="true">
            <p-messages [(value)]="step2msg"></p-messages>

        </p-accordionTab>
    </div>

    <div class="shadow-box">
        <p-accordionTab header="Period Transactions" [selected]="true">
            <div class="row">
                <div class="col">
                    <ef-schedules-presenter [schedules]="schedules" [IsDialogVisible$]="IsDialogVisible$"
                        (GetProcessScheduleIDs)="
                            onGetProcessScheduleIDs($event)
                        " (GetStep1BtnStatus)="onGetStep1BtnStatus($event)"
                        (GetStep2BtnStatus)="onGetStep2BtnStatus($event)" (GetContracts)="onGetContracts($event)"
                        (StatusPending)="onStatusPending($event)" [dialogAction$]="dialogAction$.asObservable()"
                        [clearSelectedSchedules$]="clearSelectedSchedules$">
                    </ef-schedules-presenter>
                </div>

                <div class="col col-lg-4">
                    <ef-contracts-presenter [loading]="contractsLoading" [schedules]="schedules"
                        [dialogAction$]="dialogAction$.asObservable()" [contracts]="contracts"
                        [initialContracts]="initialContracts" (DisableStep2)="onDisableStep2($event)"
                        (EnableStep2)="onEnableStep2($event)" (ApplyInvoiceChanges)="onApplyInvoiceChanges($event)"
                        (GetContracts)="onGetContracts($event)" (GetSchedules)="onGetSchedules($event)"
                        (StopAnimation)="onStopAnimation($event)">
                    </ef-contracts-presenter>
                </div>

                <div class="col col-lg-2">
                    <ef-settings-presenter [schedules]="schedules" [settings]="settings"
                        (UpdateSettings)="onUpdateSettings($event)" (GetSchedules)="onGetSchedules($event)">
                    </ef-settings-presenter>
                </div>
            </div>
        </p-accordionTab>
    </div>
</p-accordion> -->
<div class="shadow-box mt-4" style="height: 100%;">
    <p-panel header="Period Transactions">
        <div class="flex flex-column flex-auto">
            <div class="grid">
                <div class="col-12">
                    <div class="surface-card shadow-2 border-round">
                        <form [formGroup]="actionFormGroup" #addForm="ngForm" id="actionForm">
                            <p-toolbar>
                                <button pButton pRipple class="p-button-secondary" icon="pi pi-plus-circle" class="p-button-secondary" [title]="
                                                    !(hasValidTokens && qboEnabled)
                                                        ? 'Please connect to QuickBooks first.'
                                                        : 'Import ALL QuickBooks transactions for selected periods.  For reprocessing, use the Resync QuickBooks GL feature when changes impact only INDIRECT costs. QuickBooks administrator access required'
                                                " label="STEP 1: Import from QuickBooks" [disabled]="
                                                    IsStep1BtnDisabled || !qboEnabled || !hasValidTokens
                                                " (click)="step1Clicked(false)"></button>
                                <button pButton pRipple [title]="step2Tooltip" [disabled]="IsStep2BtnDisabled" class="p-button-secondary"
                                    icon="pi pi-plus-circle" label="STEP 2: Calculate and Burden" (click)="step2Clicked()"></button>
                                <button pButton pRipple [title]="step3Tooltip" [disabled]="!IsStatusPending" class="p-button-secondary"
                                    icon="pi pi-plus-circle" label="STEP 3: Commit Pending Periods" (click)="step3Clicked()"></button>
                                <button pButton pRipple
                                    title="Resync QuickBooks general ledger accounts if entries have been made in QuickBooks AFTER the period is processed.  To ensure a detailed audit trail, adjustments to DIRECT charges require period reprocessing.  Select periods or check full FY option."
                                    class="p-button-secondary" icon="pi pi-plus-circle" label="Sync GL Only" [disabled]="
                                                    IsStep1BtnDisabled || !qboEnabled || !hasValidTokens
                                                " (click)="step1Clicked(true)"></button>
                            </p-toolbar>
                        </form>
                    </div>
                </div>
                <div class="xl:col-6 lg:col-12 md:col-12 sm:col-12">
                    <div class="surface-card shadow-2 border-round">
                        <ef-schedules-presenter [schedules]="schedules"
                            [IsDialogVisible$]="IsDialogVisible$"
                            (GetProcessScheduleIDs)="
                                onGetProcessScheduleIDs($event)
                            " (GetStep1BtnStatus)="onGetStep1BtnStatus($event)"
                            (GetStep2BtnStatus)="onGetStep2BtnStatus($event)"
                            (GetContracts)="onGetContracts($event)"
                            (StatusPending)="onStatusPending($event)"
                            [dialogAction$]="dialogAction$.asObservable()"
                            [clearSelectedSchedules$]="clearSelectedSchedules$">
                        </ef-schedules-presenter>
                    </div>
                </div>

                <div class="xl:col-4 lg:col-8 md:col-8 sm:col-12">
                    <div class="surface-card shadow-2 border-round">
                        <ef-contracts-presenter [loading]="contractsLoading" [schedules]="schedules"
                            [dialogAction$]="dialogAction$.asObservable()" [contracts]="contracts"
                            [initialContracts]="initialContracts" (DisableStep2)="onDisableStep2($event)"
                            (EnableStep2)="onEnableStep2($event)" (ApplyInvoiceChanges)="onApplyInvoiceChanges($event)"
                            (GetContracts)="onGetContracts($event)" (GetSchedules)="onGetSchedules($event)"
                            (StopAnimation)="onStopAnimation($event)">
                        </ef-contracts-presenter>
                    </div>
                </div>

                <div class="xl:col-2 lg:col-4 md:col-4 sm:col-12">
                    <div class="surface-card shadow-2 border-round">
                        <ef-settings-presenter [schedules]="schedules" [settings]="settings"
                            (UpdateSettings)="onUpdateSettings($event)" (GetSchedules)="onGetSchedules($event)">
                        </ef-settings-presenter>
                    </div>
                </div>
            </div>
        </div>
    </p-panel>
</div>
